//#region Imports

import {InjectionToken} from '@angular/core';
import {EwToaster} from '@ew/ew-services-interfaces';

//#endregion

//#region Calendar

export const DATE_FORMATTER = new InjectionToken<any>('DATE_FORMATTER');
export const I18N_PlURAL_PIPE = new InjectionToken<any>('I18N_PlURAL_PIPE');

//#endregion

/**
 * EW_TOASTER injection token used to inject the toaster service.
 */
export const EW_TOASTER = new InjectionToken<EwToaster>('EW_TOASTER');
